import * as React from 'react'
import {IFeatureLayerInfo, IQuery} from '../../interfaces/models'
import OverlayLoader from '../../components/Loading/OverlayLoading'
import {ServiceHub} from '../../ServiceHub'

interface State {
  loading: boolean
  count?: number
}

interface Props {
  layerInfo: IFeatureLayerInfo
  groupField: string
  query: IQuery
}

class GroupCountColumnCell extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      loading: true
    }
  }

  componentDidMount() {
    this.loadCount(this.props)
  }
  componentDidUpdate(prevProps: Props) {
    if (prevProps.query !== this.props.query || prevProps.layerInfo !== this.props.layerInfo) {
      this.loadCount(this.props)
    }
  }

  loadCount = (props: Props) => {
    ServiceHub.gisCrudService
      .executeForCount(props.layerInfo, props.query)
      .then(c => {
        this.setState({...this.state, loading: false, count: c})
      })
      .catch(e => {
        this.setState({...this.state, loading: false, count: undefined})
      })
  }

  render() {
    return this.state.loading ? (
      <OverlayLoader size="20px" show={true} />
    ) : this.state.count ? (
      <div>{this.state.count}</div>
    ) : (
      <div>Възникна грешка</div>
    )
  }
}

export default GroupCountColumnCell
